export default "/images/b8447410d0bccb7b5672cf04d7fe7b5b.avif";